package components.project.configuration.pricestrend

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.configuration.components.Einspeiseart
import it.neckar.lizergy.model.energy.economics.PricePerKWh
import it.neckar.open.formatting.format
import it.neckar.open.unit.currency.ct
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import react.*
import react.dom.*

/**
 *
 */
fun RBuilder.pricesTrendScenarioForm(
  guaranteedFeedInPrice: StateInstance<@ct Double?>,
  consumptionPrice: StateInstance<@ct Double>,
  consumptionPriceIncreasePercentage: StateInstance<Double>,
  fallbackGuaranteedFeedInPrice: PricePerKWh,
  einspeiseart: Einspeiseart,
  editableStatus: EditableStatus,
): Unit = child(PricesTrendScenarioForm) {
  attrs {
    this.guaranteedFeedInPrice = guaranteedFeedInPrice
    this.consumptionPrice = consumptionPrice
    this.consumptionPriceIncreasePercentage = consumptionPriceIncreasePercentage
    this.fallbackGuaranteedFeedInPrice = fallbackGuaranteedFeedInPrice
    this.einspeiseart = einspeiseart
    this.editableStatus = editableStatus
  }
}

val PricesTrendScenarioForm: FC<PricesTrendScenarioFormProps> = fc("pricesTrendScenarioForm") { props ->
  val guaranteedFeedInPrice = props::guaranteedFeedInPrice.getNotNull()
  val consumptionPrice = props::consumptionPrice.getNotNull()
  val consumptionPriceIncreasePercentage = props::consumptionPriceIncreasePercentage.getNotNull()
  val einspeiseart = props::einspeiseart.getNotNull()
  val fallbackGuaranteedFeedInPrice = props::fallbackGuaranteedFeedInPrice.safeGet()
  val editableStatus = props::editableStatus.safeGet()


  div("form-floating my-3") {
    div("row gx-0") {
      div("col-lg-4") {
        div("input-group") {
          nullableFloatingDoubleInputField(
            valueAndSetter = guaranteedFeedInPrice,
            fieldName = "guaranteedFeedInPrice",
            title = "Einspeisevergütung ${if (guaranteedFeedInPrice.value == null) fallbackGuaranteedFeedInPrice.price.cents.format(2) else ""}",
            numberConstraint = ZeroOrPositive,
            editableStatus = editableStatus,
          ) {
            attrs {
              mergedRight()
            }
          }
          span("input-group-text") {
            +"ct / kWh"
          }
        }
      }

      if (einspeiseart == Einspeiseart.Ueberschuss) {
        div("col-lg-4") {
          div("form-floating") {
            div("input-group") {
              floatingDoubleInputField(
                valueAndSetter = consumptionPrice,
                fieldName = "consumptionPrice",
                title = "Netzbezugspreis",
                numberConstraint = ZeroOrPositive,
                editableStatus = editableStatus,
              ) {
                attrs {
                  mergedLeft()
                  mergedRight()
                  step = "0.1"
                }
              }
              span("input-group-text") {
                +"ct / kWh"
              }
            }
          }
        }

        div("col-lg-4") {
          div("form-floating") {
            div("input-group") {
              floatingDoubleInputField(
                valueAndSetter = consumptionPriceIncreasePercentage,
                fieldName = "consumptionPriceIncreasePercentage",
                title = "Jährliche Strompreiserhöhung",
                numberOfDecimals = 1,
                numberConstraint = ZeroOrPositive,
                editableStatus = editableStatus,
              ) {
                attrs {
                  mergedLeft()
                  step = "0.1"
                }
              }
              span("input-group-text") {
                +"%"
              }
            }
          }
        }
      }

    }

  }
}

external interface PricesTrendScenarioFormProps : Props {
  var guaranteedFeedInPrice: StateInstance<@ct Double?>
  var consumptionPrice: StateInstance<@ct Double>
  var consumptionPriceIncreasePercentage: StateInstance<Double>
  var fallbackGuaranteedFeedInPrice: PricePerKWh
  var einspeiseart: Einspeiseart
  var editableStatus: EditableStatus
}
